import { render, staticRenderFns } from "./Tips.vue?vue&type=template&id=9904f4a6&scoped=true&"
import script from "./Tips.vue?vue&type=script&lang=js&"
export * from "./Tips.vue?vue&type=script&lang=js&"
import style0 from "./Tips.vue?vue&type=style&index=0&id=9904f4a6&lang=scss&scoped=true&"
import style1 from "./Tips.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9904f4a6",
  null
  
)

export default component.exports